export default function(value) {
  return (value && "Yes") || "No";
}
